import moment from 'moment';
import templateStr from 'has-text?financials!./claim-summary.html';
import allowedPolicyTypes from 'gw-portals-featuredetection-js/AllowedPolicyTypes';
import _ from 'lodash';

export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            title: '@',
            policyNumber: '@',
            account: '=',
            policyType: '@'
        },

        controller: ['$q', 'ModalService', '$scope', '$filter', 'AccountService', 'PolicyService', '$stateParams', 'InsuranceSuiteMetadata', 'UserService', ($q, ModalService, $scope, $filter, AccountService, PolicyService, $stateParams, InsuranceSuiteMetadata, UserService) => {
            $scope.loading = true;
            const claimStatePSA = InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState'); // PSA
            //UCWPRODENG-875
            $scope.canCreateClaim = false;
            init();

            function init() {
                if (angular.isDefined($scope.policyType)) {
                    $scope.fileClaimAllowed = allowedPolicyTypes.names.includes($scope.policyType);
                } else {
                    $scope.fileClaimAllowed = accountHasClaimLOBLines($scope.account);
                }

                $scope.tableConfig = {
                    claimLOB: '',
                    showClosedClaims: false,
                    claimLOBOptions: [],
                    search: ''
                };

                $scope.hideNonPolicyFields = false;

                if (angular.isDefined($scope.account)) {
                    $scope.claimsPromise = getAccountClaims($scope.account.accountNumber).then(
                        (accountClaims) => {
                            $scope.claimSummaries = accountClaims;
                            getClaimLOBOptions($scope.claimSummaries);
                            if (accountClaims.length === 0) {
                                $scope.claimSummariesReturnMessage = $filter('translate')('gateway.directives.ClaimSummaryDirective.ClaimSummary.There are no claims');
                            }
                            $scope.loading = false;
                        },
                        () => {
                            $scope.claimSummariesReturnMessage = $filter('translate')('gateway.directives.ClaimSummaryDirective.ClaimSummary.Failed to retrieve claims data');
                            ModalService.showError('gateway.views.modal.Error', 'gateway.directives.ClaimSummaryDirective.ClaimSummary.Failed to retrieve claims data');
                        }
                    );
                } else if (angular.isDefined($scope.policyNumber)) {
                    $scope.claimsPromise = getPolicyClaims($scope.policyNumber).then(
                        (policyClaims) => {
                            $scope.claimSummaries = policyClaims;
                            if (policyClaims.length === 0) {
                                $scope.claimSummariesReturnMessage = $filter('translate')('gateway.directives.ClaimSummaryDirective.ClaimSummary.There are no claims');
                            }
                            $scope.hideNonPolicyFields = true;
                            $scope.loading = false;
                        },
                        () => {
                            $scope.claimSummariesReturnMessage = $filter('translate')('gateway.directives.ClaimSummaryDirective.ClaimSummary.Failed to retrieve claims data');
                        }
                    );
                }
                //UCWPRODENG-875
                checkCreateClaimPermission();
            }

            $scope.getNonEmptyPSA = (name) => {
                return name || "-";
            };

            $scope.getDraftStatus = () => {
                return claimStatePSA.getCode('draft').name;
            };

            function getAccountClaims(accountNumber) {
                if (!accountNumber) {
                    accountNumber = $stateParams.accountNumber;
                }
                return AccountService.getAccountClaims(accountNumber);
            }

            function getPolicyClaims(policyNumber) {
                return PolicyService.getPolicyClaims(policyNumber);
            }

            function getClaimLOBOptions(claims) {
                const claimLOBOptions = [$filter('translate')('gateway.directives.ClaimSummaryDirective.ClaimSummary.Filters')];
                claims.forEach((claim) => {
                    if (claimLOBOptions.indexOf(claim.product) <= -1) {
                        claimLOBOptions.push(claim.product);
                    }
                });

                $scope.tableConfig.claimLOBOptions = claimLOBOptions.map((key) => {
                    return {
                        key,
                        value: key
                    };
                });

                $scope.tableConfig.claimLOB = $scope.tableConfig.claimLOBOptions[0];
            }

            $scope.getFilteredClaimSummaries = () => {
                let filteredSummaries = $scope.claimSummaries;

                if ($scope.tableConfig.claimLOB) {
                    filteredSummaries = $filter('filter')(filteredSummaries, filterByLOB);
                }
                if ($scope.tableConfig.search) {
                    filteredSummaries = $filter('filter')(filteredSummaries, claimSearchFilter);
                }

                return filteredSummaries;
            };

            function filterByLOB(claim) {
                const allLobsString = $filter('translate')('gateway.directives.ClaimSummaryDirective.ClaimSummary.Filters');
                if ($scope.tableConfig.claimLOB.value === allLobsString) {
                    return true;
                }

                return claim.product === $scope.tableConfig.claimLOB.value;
            }

            const claimSearchFilter = (claim) => {
                const lowerCaseSearch = _.lowerCase($scope.tableConfig.search);

                if (angular.isDefined($scope.accountNumber)) {
                    return claimDateFilter(lowerCaseSearch, claim.lossDate) ||
                        stringFilter(lowerCaseSearch, claim.claimNumber) ||
                        stringFilter(lowerCaseSearch, claim.policyNumber) ||
                        stringFilter(lowerCaseSearch, claim.product) ||
                        stringFilter(lowerCaseSearch, claim.status);
                }
                return claimDateFilter(lowerCaseSearch, claim.lossDate) ||
                    stringFilter(lowerCaseSearch, claim.claimNumber) ||
                    stringFilter(lowerCaseSearch, claim.status);
            };

            function claimDateFilter(search, lossDate) {
                return (angular.isDefined(lossDate) && _.lowerCase($filter('date')(lossDate, 'longDate')).indexOf(search || '') !== -1);
            }

            function stringFilter(search, aString) {
                return (angular.isDefined(aString) && _.lowerCase(aString).indexOf(search || '') !== -1);
            }

            function accountHasClaimLOBLines(account) {
                if (angular.isDefined(account) &&
                    angular.isDefined(account.policySummaries) && account.policySummaries.length > 0) {

                    return account.policySummaries.some((policySummary) =>
                        policySummary.policyLines.some((line) =>
                            allowedPolicyTypes.names.includes(line.lineOfBusinessCode)));
                }

                return false;
            }

            $scope.getDraftStatus = () => {
                return InsuranceSuiteMetadata.get('cc').types.getTypelist('ClaimState').getCode('draft').name;
            };

            $scope.canFileClaimPolicy = () => {
                //UCWPRODENG-875
                if( $scope.canCreateClaim == false){
                    return  $scope.canCreateClaim ;
                }
                else return (allowedPolicyTypes.names.includes($scope.policyType) &&
                    angular.isDefined($scope.policyNumber) && !$scope.$parent.policy.latestPeriod.canceled &&
                    checkIfPolicyIsInForceStatus($scope.$parent.policy.latestPeriod)) ;
            };

            function checkIfPolicyIsInForceStatus(latestPeriod) {
                return latestPeriod.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Bound').name && !moment().isBefore(moment(latestPeriod.effectiveDate));
            }

            $scope.canFileClaimAccount = () => {
                //UCWPRODENG-875
                if( $scope.canCreateClaim == false){
                    return  $scope.canCreateClaim ;
                }
                return accountHasClaimLOBLines($scope.account) && angular.isDefined($scope.account.accountNumber);
            };
            //UCWPRODENG-875
            function checkCreateClaimPermission() {
                const permissionDTO = {
                    permission: 'claimcreate'
                };

                const permCheckPromise = UserService.hasUserSystemPermissionforClaim(permissionDTO, "cc");

                permCheckPromise.then((canCreateClaim) => {
                    $scope.canCreateClaim = canCreateClaim;
                });
            }
        }]
    };
};